import { Boss, BossDef, BossAttack } from './boss';
import { GAME, ASSETS } from '../config';

// boss-tougher (boss 2026-06-13「魔王要夠強,太弱沒挑戰性」但仍要可躲):
//   tier2 各魔王 HP 往上(更肉 → 撐久 → 要持續走位 + 靠學習戰力出 DPS),phase2HpThreshold
//   同步抬到約 40% HP(變身衝刺段更長更兇)。這些 TS 值是 bosses.json 的「pre-override base」
//   (執行期由 applyBossBalance 用 JSON 覆蓋),此處與 JSON 同步以保持一致並通過單測。
//   可躲鐵則:招式種類 / 子彈速度 / cooldown / 安全縫一律不動,只調 hp / phase2 門檻。
const SHU_FU: BossDef = {
  id: 'shu-fu',
  displayName: '數符雙煞',
  hp: 1150,
  speedPxPerSec: 35,
  // boss-behavior: 112→164 (×1.46).
  size: 164,
  color: 0x7c1fa1,
  assetKey: ASSETS.bossShuFu,
  shape: 'diamond',
  faction: 'celestial',
  affinityFaction: 'celestial', // 數符雙煞 = math+runic hybrid; dominant math theme = celestial
  tier: 2,
  attackACooldownMs: 3500,
  attackBCooldownMs: 5500,
  phase2HpThreshold: 460,
  attackBWarningMs: 1000,
  introDialog: '雙魔合擊,計算與封印雙生...',
  arenaTint: 0x2a0a2a,
  entranceCinematic: 'phase-in',
  deathCinematic: 'fragment-into-pieces',
  uniqueGimmick: 'mirror-player',
  tickAttacks(self: Boss, nowMs: number, playerX: number): BossAttack[] {
    const out: BossAttack[] = [];
    if (self.y < self.def.size / 2) return out;
    if (nowMs - self.lastAttackAMs >= self.effectiveAttackACooldownMs) {
      self.lastAttackAMs = nowMs;
      const useShot = Math.floor(nowMs / self.def.attackACooldownMs) % 2 === 0;
      if (useShot) {
        const angle = Math.atan2(playerX - self.x, GAME.height * 0.85 - self.y);
        out.push({ kind: 'single-shot', angleRad: angle, speedPxPerSec: 380, damage: 20 });
      } else {
        out.push({ kind: 'silence-wave', radiusPx: 200, durationMs: 600 });
      }
    }
    if (self.phase === 2 && nowMs - self.lastAttackBMs >= self.effectiveAttackBCooldownMs) {
      self.lastAttackBMs = nowMs;
      out.push({ kind: 'spawn-minions', count: 2 });
      out.push({ kind: 'homing-shot', count: 3, speedPxPerSec: 215, turnRatePerSec: 110, damage: 13 });
      // boss-phase2-transform (老闆「攻擊方式要改變 動態變換」):phase2 新招 —
      //   ring-burst 環形彈幕 (phase1 只有單發/沉默波,從不放環),雙層+缺口+緩旋,
      //   讓數符雙煞變身後從「點射控場」轉成「環形鋪面+追蹤」打法。衝缺口可躲。
      out.push({ kind: 'ring-burst', count: 18, speedPxPerSec: 150, damage: 8, layers: 2, gapRad: 0.9, rotateDps: 35 });
    }
    return out;
  },
};

const JI_YUAN: BossDef = {
  id: 'ji-yuan',
  displayName: '機元雙影',
  hp: 1100,
  speedPxPerSec: 45,
  // boss-behavior: 108→158 (×1.46).
  size: 158,
  color: 0x00acc1,
  assetKey: ASSETS.bossJiYuan,
  shape: 'hexagon',
  faction: 'techno',
  affinityFaction: 'techno', // 機元雙影 = mech+elemental hybrid; dominant mech theme = techno
  tier: 2,
  attackACooldownMs: 3500,
  attackBCooldownMs: 5500,
  phase2HpThreshold: 440,
  attackBWarningMs: 1000,
  introDialog: 'drone swarm 載入中...',
  arenaTint: 0x0a1a2a,
  entranceCinematic: 'descend',
  deathCinematic: 'explode-standard',
  uniqueGimmick: 'spawn-orbiting-minions',
  tickAttacks(self: Boss, nowMs: number, playerX: number): BossAttack[] {
    const out: BossAttack[] = [];
    if (self.y < self.def.size / 2) return out;
    if (nowMs - self.lastAttackAMs >= self.effectiveAttackACooldownMs) {
      self.lastAttackAMs = nowMs;
      out.push({ kind: 'spawn-minions', count: 4 });
    }
    if (self.phase === 2 && nowMs - self.lastAttackBMs >= self.effectiveAttackBCooldownMs) {
      self.lastAttackBMs = nowMs;
      // boss-behavior: 5 → 8 道扇形 + 速度偵察門派 → 較多較快追蹤彈.
      out.push({ kind: 'fan-shot', angles: [-0.7, -0.5, -0.3, -0.1, 0.1, 0.3, 0.5, 0.7], speedPxPerSec: 320, damage: 12 });
      out.push({ kind: 'homing-shot', count: 4, speedPxPerSec: 235, turnRatePerSec: 130, damage: 10 });
      // boss-phase2-transform (老闆「攻擊方式要改變 動態變換」):phase2 新招 —
      //   beam-cast 高速光束 (phase1 只有召喚無人機,從不放光束),朝玩家瞄準一發,
      //   速度偵察門派的「偵測鎖定」變身招。單發瞄準 → 玩家側移即可閃 (K-3 可躲)。
      const angle = Math.atan2(playerX - self.x, GAME.height * 0.85 - self.y);
      out.push({ kind: 'beam-cast', angleRad: angle, speedPxPerSec: 520, damage: 14 });
    }
    return out;
  },
};

const XING_YU: BossDef = {
  id: 'xing-yu',
  displayName: '星域守衛',
  hp: 1280,
  speedPxPerSec: 30,
  // boss-behavior: 120→176 (×1.47).
  size: 176,
  color: 0x1565c0,
  assetKey: ASSETS.bossXingYu,
  shape: 'double-circle',
  faction: 'celestial',
  affinityFaction: 'dominion', // 星域守衛 = territorial star guardian = dominion (territorial control)
  tier: 2,
  attackACooldownMs: 3500,
  attackBCooldownMs: 5500,
  phase2HpThreshold: 512,
  attackBWarningMs: 1000,
  introDialog: '守護星域,擊敗我之前你別想前進',
  arenaTint: 0x1a1a0a,
  entranceCinematic: 'rise-from-ground',
  deathCinematic: 'crystal-shatter',
  uniqueGimmick: 'phase-shield',
  tickAttacks(self: Boss, nowMs: number, playerX: number): BossAttack[] {
    const out: BossAttack[] = [];
    if (self.y < self.def.size / 2) return out;
    if (nowMs - self.lastAttackAMs >= self.effectiveAttackACooldownMs) {
      self.lastAttackAMs = nowMs;
      const angle = Math.atan2(playerX - self.x, GAME.height * 0.85 - self.y);
      out.push({ kind: 'beam-cast', angleRad: angle, speedPxPerSec: 550, damage: 30 });
    }
    if (self.phase === 2 && nowMs - self.lastAttackBMs >= self.effectiveAttackBCooldownMs) {
      self.lastAttackBMs = nowMs;
      out.push({ kind: 'spawn-minions', count: 3, bonusSpeed: 60 });
      out.push({ kind: 'homing-shot', count: 3, speedPxPerSec: 220, turnRatePerSec: 110, damage: 14 });
      // boss-phase2-transform (老闆「攻擊方式要改變 動態變換」):phase2 新招 —
      //   ring-burst 區域封鎖環 (phase1 只有瞄準光束,從不放環),疆域門派的領域封鎖,
      //   讓星域守衛變身後從「精準狙擊」轉成「鋪面封鎖+追蹤」。雙層+缺口,衝缺口可躲。
      out.push({ kind: 'ring-burst', count: 18, speedPxPerSec: 155, damage: 8, layers: 2, gapRad: 0.9, rotateDps: 35 });
    }
    return out;
  },
};

const ZI_FU: BossDef = {
  id: 'zi-fu',
  displayName: '自符魂使',
  hp: 1200,
  speedPxPerSec: 38,
  // boss-behavior: 110→160 (×1.45).
  size: 160,
  color: 0xe65100,
  assetKey: ASSETS.bossZiFu,
  shape: 'hexagon',
  faction: 'elemental',
  affinityFaction: 'elemental', // 自符魂使 = natural-spirit runic master; elemental theme dominant
  tier: 2,
  attackACooldownMs: 3500,
  attackBCooldownMs: 5500,
  phase2HpThreshold: 480,
  attackBWarningMs: 1000,
  introDialog: '靈魂之火,焚盡符印!',
  arenaTint: 0x2a1a0a,
  entranceCinematic: 'teleport-in',
  deathCinematic: 'fade-into-data',
  uniqueGimmick: 'echo-attacks',
  tickAttacks(self: Boss, nowMs: number, playerX: number): BossAttack[] {
    const out: BossAttack[] = [];
    if (self.y < self.def.size / 2) return out;
    if (nowMs - self.lastAttackAMs >= self.effectiveAttackACooldownMs) {
      self.lastAttackAMs = nowMs;
      out.push({ kind: 'freeze-player', durationMs: 800 });
      const angle = Math.atan2(playerX - self.x, GAME.height * 0.85 - self.y);
      out.push({ kind: 'single-shot', angleRad: angle, speedPxPerSec: 400, damage: 22 });
    }
    if (self.phase === 2 && nowMs - self.lastAttackBMs >= self.effectiveAttackBCooldownMs) {
      self.lastAttackBMs = nowMs;
      out.push({ kind: 'silence-wave', radiusPx: 180, durationMs: 500 });
      // boss-behavior: 3 → 7 道扇形 + 追蹤彈.
      out.push({ kind: 'fan-shot', angles: [-0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6], speedPxPerSec: 300, damage: 13 });
      out.push({ kind: 'homing-shot', count: 3, speedPxPerSec: 215, turnRatePerSec: 110, damage: 12 });
      // boss-phase2-transform (老闆「攻擊方式要改變 動態變換」):phase2 新招 —
      //   magic-bolt 靈火波 (phase1 只有凍結+直線單發,從不放波浪魔法彈),自然之火的
      //   變身招,波形前進玩家可看波預判閃。讓自符魂使從「點射控場」轉成「靈火鋪面」。
      out.push({ kind: 'magic-bolt', count: 4, speedPxPerSec: 220, amplitudePx: 44, periodMs: 880, damage: 9 });
    }
    return out;
  },
};

export const TIER2_BOSS_POOL: BossDef[] = [SHU_FU, JI_YUAN, XING_YU, ZI_FU];

export function pickRandomTier2Boss(rand: () => number = Math.random): BossDef {
  return TIER2_BOSS_POOL[Math.floor(rand() * TIER2_BOSS_POOL.length)];
}